module.exports = __webpack_public_path__ + "static/media/A034_01210425_C026_LRes@3x.4db7cef6.png";